import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft, FaEnvelope } from 'react-icons/fa';

const SUPPORT_EMAIL = 'suporte@abastecemaisapp.com.br';

const Support: React.FC = () => {
  return (
    <div className="min-h-screen bg-[#0f1419] text-white">
      <div className="max-w-4xl mx-auto px-6 py-10">
        <div className="flex items-center justify-between mb-6">
          <Link
            to="/login"
            className="flex items-center gap-2 text-[#84cc34] hover:text-[#089453] transition-colors"
          >
            <FaArrowLeft />
            Voltar
          </Link>
          <span className="text-white/50 text-sm">Suporte Abastece+</span>
        </div>

        <h1 className="text-3xl font-bold mb-4">Suporte</h1>
        <p className="text-white/80 leading-relaxed mb-6">
          Estamos aqui para ajudar caminhoneiros, motoristas profissionais e qualquer motorista
          que use o Abastece+. Se tiver dúvidas, problemas ou sugestões, fale com nossa equipe.
        </p>

        <div className="bg-[#1a2332] border border-white/10 rounded-2xl p-6 mb-6">
          <h2 className="text-xl font-semibold mb-3">Canais de atendimento</h2>
          <a
            href={`mailto:${SUPPORT_EMAIL}`}
            className="flex items-center gap-3 text-[#84cc34] hover:text-[#089453] transition-colors"
          >
            <FaEnvelope />
            {SUPPORT_EMAIL}
          </a>
          <p className="text-white/60 text-sm mt-2">Resposta em até 1 dia útil.</p>
        </div>

        <div className="bg-[#1a2332] border border-white/10 rounded-2xl p-6 mb-6">
          <h2 className="text-xl font-semibold mb-3">Para agilizar o atendimento</h2>
          <ul className="list-disc list-inside text-white/75 space-y-1">
            <li>Informe seu nome e e-mail de cadastro.</li>
            <li>Descreva o problema com detalhes.</li>
            <li>Se possível, envie prints da tela.</li>
          </ul>
        </div>

        <div className="bg-[#1a2332] border border-white/10 rounded-2xl p-6">
          <h2 className="text-xl font-semibold mb-3">Perguntas frequentes</h2>
          <p className="text-white/75">• Não consigo fazer login: verifique seu e-mail e senha.</p>
          <p className="text-white/75">• Solicitação do posto pendente: nossa equipe confere o CNPJ antes de aprovar.</p>
          <p className="text-white/75">• Conta do posto não entra no app: ela acessa apenas este portal.</p>
        </div>
      </div>
    </div>
  );
};

export default Support;
